module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Game over!")]), _c('v-layout', {
    attrs: {
      "ma-3": "",
      "column": ""
    }
  }, [(_vm.result == 'FASCIST_HITLER') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            Hitler was elected chancellor\n        ")]) : (_vm.result == 'LIBERAL_HITLER') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            Hitler was assassinated\n        ")]) : (_vm.result == 'FASCIST_POLICY') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            6 fascist policies were enacted\n        ")]) : (_vm.result == 'LIBERAL_POLICY') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            5 liberal policies were enacted\n        ")]) : _vm._e(), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticClass: "policy",
    class: _vm.team
  })])], 1), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Continue")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0f7054","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/COMPLETED/index.vue
// module id = 310
// module chunks = 0